import type { AuthUser } from '@repo/shared-types';
import { useEffect } from 'react';
import { apiFetch } from '@/lib/api';
import { useAuthStore } from '@/stores/auth.store';

interface MeResponse {
  user: AuthUser;
  token: string;
  expiresAt: string;
}

export function useInitAuth(): void {
  const hasHydrated = useAuthStore((s) => s._hasHydrated);

  useEffect(() => {
    if (!hasHydrated) return;

    const currentToken = useAuthStore.getState().token;
    if (!currentToken) return;

    let cancelled = false;
    apiFetch<MeResponse>('/auth/me')
      .then(({ token, user }) => {
        if (!cancelled) useAuthStore.getState().setSession({ token, user });
      })
      .catch(() => {});

    return () => {
      cancelled = true;
    };
  }, [hasHydrated]);
}
